<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="inspIndexNo"
    item-value="inspIndexNo"
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'MmmmInspIndexInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0137')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    inspTimingCd: {
      type: String,
      required: true,
    },
    manufacturerCd: {
      type: String,
      required: true,
    },
    partCd: {
      type: String,
      required: true,
    },
    lotNo: {
      type: String,
      required: false,
      default: '',
    },
    inspStatusCd: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  watch: {
    async lotNo(value) {
      await this.setInspIndexes(this.manufacturerCd, this.partCd, value)
    },
  },

  methods: {
    async setInspIndexes(manufacturerCd, partCd, lotNo) {
      this.loading = true
      this.items = []

      try {
        if (manufacturerCd && partCd && lotNo) {
          let params = {
            inspTimingCd: this.inspTimingCd,
            manufacturerCd: manufacturerCd,
            partCd: partCd,
            lotNo: lotNo,
            inspStatusCd: this.inspStatusCd,
          }

          this.items = await API.get('/inspIndex/inspIndexes/mmmm', params)
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0137') })))
      } finally {
        this.loading = false
      }
    },
  },

  async mounted() {
    await this.setInspIndexes(this.manufacturerCd, this.partCd, this.lotNo)
  },
}
</script>
